export const fonts = {
	heading: "Lato",
	body: "Lato",
};
